import React from 'react'
import './BookList.css'
import youTubeIcon from '../../images/youtube_social_icon_red.png'

function Book(props) {
  const url = `https://www.ehonnavi.net${props.book.url}`
  const isRead = (props.completedBooks.filter(bk => bk.url === url)).length > 0
  return (
    <li className={isRead ? 'read' : 'unread'}>
      <div className="title">
        <a href={url} target="_blank" rel="noopener noreferrer">{props.book.title}</a>
      </div>
      {props.book.readAloudUrl && (
        <a href={props.book.readAloudUrl} target="_blank" rel="noopener noreferrer" className="youtube" name="Read aloud link">
          <img src={youTubeIcon} alt="YouTube Icon" />
        </a>
      )} 
      <button
        className="star"
        onClick={(e) => props.toggleBookComplete(e, props.book, props.age)}
      >
        &#9733;
      </button>
    </li>
  )
}

function BookList(props) {
  const listItems = props.books.map(book => (
    <Book
      key={book.url}
      age={props.age}
      completedBooks={props.completedBooks}
      book={book}
      toggleBookComplete={props.toggleBookComplete}
    />
  ))
  return (
    <ul className="book-list">
      {listItems}
    </ul>
  )
}

export default BookList
